import { LinearProgress } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { PageContainer } from '../containers';

export const DefaultTemplate = (props) => {
    return (
        <Suspense fallback={<LinearProgress />}>
            <PageContainer>
                <Outlet />
            </PageContainer>
        </Suspense>
    );
};
